import { FC, ReactNode } from "react";
import { Tag } from "antd";
import styles from "./roleTag.module.css";

type RoleTagProps = {
  className?: string;
  children: ReactNode;
};

export const RoleTag: FC<RoleTagProps> = ({ children, className = "" }) => {
  return (
    <Tag color="default" className={`${styles.tag} ${className}`} bordered={false}>
      {children}
    </Tag>
  );
};
